import config from "src/config/config";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import { theme } from 'styled-tools';

type LinkItem = {
  key: string;
  title: string;
  href: string;
  Icon: any;
};



const AboutLinks = (props:any) => {
         const { app: {
    brandId
  }, theme } = props
        const { showOnlyOnFun } = theme.config
        const domain =
    brandId == 31 || brandId == 32 || brandId == 61
      ? "YOLO247"
      : brandId == 39 || brandId == 40 || brandId == 37
        ? "FOMO7" 
        : brandId == 46 || brandId == 47 || brandId == 49
        ? "FUN88"
        : "IW247";
    

        const PAGE_LINKS: LinkItem[] = [
            { key: "about", title: `About ${domain}`, href: "/about/about-us", Icon: ['/static/media/about-link-icon.png', '/static/media/about-link-icon-fun.png'] },
            { key: "tnc", title: "Terms & Conditions", href: "/about/terms-conditions", Icon: ['/static/media/terms-link-icon.png', '/static/media/terms-link-icon-fun.png'] },
            { key: "privacy", title: "Privacy Policy", href: "/about/privacy-policy", Icon: ['/static/media/privacy-links-icon.png', '/static/media/privacy-links-icon-fun.png'] },
            { key: "kyc", title: "KYC Policy", href: "/about/kyc-policy", Icon: ['/static/media/kyc-links-icon.png', '/static/media/kyc-links-icon-fun.png'] },
            { key: "self-exclusion", title: "Self Exclusion Policy", href: "/about/self-exclusion-policy", Icon: ['/static/media/self-exclusion-icon.png', '/static/media/self-exclusion-icon-fun.png'] },
            { key: "aml", title: "AML Policy", href: "/about/aml-policy", Icon: ['/static/media/aml-policy-link-icon.png', '/static/media/aml-policy-link-icon-fun.png'] },
            { key: "sponsorships", title: "Sponsorships", href: "/sponsors", Icon: ['/static/media/sponsorshit-link-icon.png', '/static/media/sponsorshit-link-icon-fun.png'] },
            { key: "press", title: "Press", href: "https://www.yolo247.live/press", Icon: ['/static/media/press-link-icon.png', '/static/media/press-link-icon-fun.png'] },
                ].filter((item) => {
                if (item.key === "press") return brandId === 31 || brandId === 32;
                else if (item.key === "sponsorships") return brandId !== 33;
                return true;
            });
  return (
    <Screen>
      <Divider></Divider>
      <Title>{domain} links</Title>

      <List>
        {PAGE_LINKS.map(({ key, title, href, Icon }) => (
          <CardLink key={key} href={href} aria-label={title}>
            <IconWrap>
              <img src={`${config.imageV3Host}${showOnlyOnFun ? Icon[1] : Icon[0]}`} height={25} width={25} alt="" loading="lazy" />
            </IconWrap>
            <CardTitle>{title}</CardTitle>
          </CardLink>
        ))}
      </List>
    </Screen>
  );
}


export default withTheme(withAppContext(AboutLinks));

/* ---------------- styles ---------------- */

const Screen = styled.main`
  min-height: calc(100vh - 107px);
  height: 100%;
  padding: 0px 28px 60px 28px;
  background: ${theme("palette.aboutLinksMainBg")};
  /* If your theme bg is plain, this adds the soft vignette feel like the screenshot */
  /* background: radial-gradient(ellipse 120% 80% at 50% 0%, #171717 0%, #000 70%); */
`;

const Title = styled.h1`
  margin: 40px 0 34px;
  text-align: center;
  font-size: 25px;
  font-weight: 700;
  letter-spacing: 0.2px;
  color: ${theme("palette.aboutLinksTitle")};

  @media (max-width: 768px) {
    font-size: 20px;
    margin: 14px 0 24px;
  }
`;

/** ✅ 2-column grid like screenshot */
const List = styled.section`
  max-width: 1400px;
  margin: 0 auto;

  display: grid;
  grid-template-columns: repeat(2, minmax(420px, 1fr));
  column-gap: 44px;
  row-gap: 32px;

  align-items: start;
  justify-content: center;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(320px, 1fr));
    column-gap: 28px;
    row-gap: 24px;
  }

  @media (max-width: 820px) {
    grid-template-columns: 1fr;
    max-width: 560px;
    row-gap: 18px;
  }
`;

/** ✅ Card look: bigger, softer, thin border */
const CardLink = styled.a`
  width: 100%;
  min-height: 86px;

  display: flex;
  align-items: center;
  gap: 18px;

  padding: 22px 22px;
  border-radius: 14px;

  background: ${theme("palette.aboutLinksLinksBg")};
  border: 1.5px solid rgba(255, 255, 255, 0.35);

  text-decoration: none;
  color: ${theme("palette.aboutLinksText")};

  /* subtle depth like screenshot */
  /* box-shadow: 0 18px 50px rgba(0, 0, 0, 0.35); */

  transition: transform 140ms ease, border-color 140ms ease, box-shadow 140ms ease;

  &:hover {
    transform: translateY(-1px);
    /* border-color: rgba(255, 255, 255, 0.55);
    box-shadow: 0 22px 60px rgba(0, 0, 0, 0.42); */
    color: ${theme("palette.aboutLinksText")};
  }

  &:active {
    transform: translateY(0px);
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.65);
    outline-offset: 4px;
  }

  @media (max-width: 820px) {
    min-height: 74px;
    padding: 18px 18px;
    border-radius: 12px;
  }
`;

const IconWrap = styled.div`
  width: 54px;
  height: 54px;
  flex: 0 0 54px;

  display: grid;
  place-items: center;

  /* no bg behind icon in screenshot */
  img {
    opacity: 0.95;
    object-fit: contain;
  }

  @media (max-width: 820px) {
    width: 46px;
    height: 46px;
    flex: 0 0 46px;
  }
`;

const CardTitle = styled.div`
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0.1px;

  @media (max-width: 820px) {
    font-size: 15px;
  }
`;

export const Divider = styled.div`
  height: 2px;
  width: 100%;
  background: ${theme("palette.aboutLinksMainTopBorder")};
  margin: 0 0 12px 0;
  opacity: 0.9;
`;